import {
	PRESENTATION_GET_LAYOUTS,
	PRESENTATION_GET_LAYOUTS_FAILURE,
	PRESENTATION_GET_LAYOUTS_SUCCESS,
	PRESENTATION_EDIT_LAYOUT,
	PRESENTATION_EDIT_LAYOUT_FAILURE,
	PRESENTATION_EDIT_LAYOUT_SUCCESS,
	PRESENTATION_LAYOUTS_PROPS_CHANGED,
	PRESENTATION_SELECTING_PROP_CHANGED,
	PRESENTATION_SECTION_SELECTED_PROP_CHANGED,
	PRESENTATION_EDITING_SECTION_PROP_CHANGED, PRESENTATION_PROPS_CHANGED,
} from "./actions";

const initialState = {
	layouts: [],
	layout: {},
	sectionEditing: null,
	newLayout: {},
	selecting: false,
	loading: false,
	saving: false,
	selectedSection: null,
	hasArticles: true,
	headerName: null,
	headerIndex: null,
};

export const presentationReducer = (state = initialState, action = {}) => {
	switch (action.type) {
		case PRESENTATION_GET_LAYOUTS:
			return {
				...state,
				loading: true,
			};
		case PRESENTATION_GET_LAYOUTS_SUCCESS:
			return {
				...state,
				loading: false,
				layouts: action.layouts,
				layout: action.layout,
				newLayout: action.newLayout,
			};
		case PRESENTATION_GET_LAYOUTS_FAILURE:
			return {
				...state,
				loading: false,
			};
		case PRESENTATION_EDIT_LAYOUT:
			return {
				...state,
				saving: true,
			};
		case PRESENTATION_EDIT_LAYOUT_SUCCESS:
			return {
				...state,
				saving: false,
				layout: action.layout,
				newLayout: action.layout,
			};
		case PRESENTATION_EDIT_LAYOUT_FAILURE:
			return {
				...state,
				saving: false,
			};
		case PRESENTATION_SELECTING_PROP_CHANGED:
			return {
				...state,
				selecting: action.selecting,
				selectedSection: action.selectedSection,
			};
		case PRESENTATION_EDITING_SECTION_PROP_CHANGED:
			return {
				...state,
				...action,
			};
		case PRESENTATION_LAYOUTS_PROPS_CHANGED:
			return {
				...state,
				newLayout: action.layout,
			};
		case PRESENTATION_SECTION_SELECTED_PROP_CHANGED:
			return {
				...state,
				sectionSelected: action.sectionSelected,
			};
		case PRESENTATION_PROPS_CHANGED:
			return {
				...state,
				...action,
			};
		default:
			return state;
	}
};
